import { useContext } from 'react';

import { AppContext } from '../AppContext';

export const useRetailerNetworkHighestRoleUserSelector = () => {
  const { retailerNetworkHighestRoleUser } = useContext(AppContext);
  return retailerNetworkHighestRoleUser;
};
